import React from 'react';
import { FaDownload } from 'react-icons/fa';

export default function CustomerFilterBar({
  search,
  setSearch,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  onExport,
  onReset,
}) {
  
  return (
    <div className="flex flex-wrap mb-4 gap-4 items-end">
      <div className="flex flex-col flex-1 min-w-[200px]">
        <label className="font-semibold mb-1 select-none">🔍 Search</label>
        <input
          type="text"
          placeholder="Name, phone, business..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div className="flex flex-col flex-[0.75] min-w-[160px]">
        <label className="font-semibold mb-1 select-none">Start Created Date</label>
        <input
          type="date"
          value={startDate}
          onChange={(e) => setStartDate(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div className="flex flex-col flex-[0.75] min-w-[160px]">
        <label className="font-semibold mb-1 select-none">End Created Date</label>
        <input
          type="date"
          value={endDate}
          onChange={(e) => setEndDate(e.target.value)}
          className="border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-500"
        />
      </div>

      <div className="flex gap-2">
        <button
          onClick={onReset}
          className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-semibold px-4 py-2 rounded transition"
          type="button"
        >
          ❌ Clear
        </button>
        <button
          onClick={onExport}
          className="bg-green-600 hover:bg-green-700 text-white font-semibold px-4 py-2 rounded flex items-center gap-1 transition"
          type="button"
        >
          <FaDownload /> Export
        </button>
      </div>
    </div>
  );
}
